/**
 * 配車計画 ドライバー配車一覧
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

 const allocation_driver_schedule = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 配車計画 ドライバー配車一覧
     * @param commit
     * @param driver_id
     * @param target_date
     * @returns {Promise<unknown>}
     */
    index ({ commit }, { driver_id, target_date }) {
      const api_path = `${API_PATH}/${driver_id}/schedules`
      const params = { target_date: target_date }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    create({ commit }, { driver_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/schedules`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          if (data.result.code) {
            commit('snackbar/showError', { message: data.result.message }, { root: true })
          }
          resolve(content)
        } )
      })
    },
    // /**
    //  * 配車解除
    //  * @param commit
    //  * @param driver_id
    //  * @param id
    //  * @param target_date
    //  * @return {Promise<unknown>}
    //  */
    // destroy ({ commit }, { driver_id, id, target_date }) {
    //   const api_path = `${API_PATH}/${driver_id}/schedules/${id}`
    //   const params = { target_date: target_date }
    //   return new Promise( ( resolve ) => {
    //     Vue.$http.delete(api_path, { params: params }).then(data => {
    //       commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
    //       resolve(data.content)
    //     })
    //   })
    // },
    /**
     * 配車キャンセル
     * @param commit
     * @param driver_id
     * @param id
     * @param target_date
     * @return {Promise<unknown>}
     */
    cancel ({ commit }, { driver_id, id, target_date }) {
      const api_path = `${API_PATH}/${driver_id}/schedules/${id}`
      const params = { target_date: target_date }
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path, { params: params }).then(data => {
          commit('snackbar/showInfo', { message: 'キャンセルしました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocation_driver_schedule
